import { AppState } from '../../..';
import { Dispatch, connect } from 'react-redux';
import {
  ContractHistoryComponentProperties,
  ContractHistoryComponent
} from 'src/contract/_components/contract-history/contract-history.component';
import { searchContractTerm } from 'src/contract/contract-history.actions';

function mapStateToProps(
  state: AppState,
  ownProps: { contractId?: number }
): Partial<ContractHistoryComponentProperties> {
  return {
    contractId: ownProps.contractId,
    message: state.contract.message,
    query: state.contract.historyQuery,
    loading: state.contract.historyLoading,
    pageCount: state.contract.historyPageCount,
    pageNumber: state.contract.historyPageNumber,
    pageSize: state.contract.historyPageSize,
    results: state.contract.historyResults
  };
}

function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<ContractHistoryComponentProperties> {
  return {
    getContractHistory: (query, pageSize, pageNumber, orderBy, orderDirection, contractId) =>
      dispatch(searchContractTerm(query, pageSize, pageNumber, orderBy, orderDirection, contractId))
  };
}

export const ContractHistory = connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractHistoryComponent);



// WEBPACK FOOTER //
// ./src/contract/_components/contract-history/contract-history.container.ts